import {FC} from 'react';
//mui
import {Box} from '@mui/material';
//components
import EventActions from '../EventActions';
import TicketsSales from './TicketsSales';
import TicketsTables from './TicketsTables';

const TableAndTickets: FC = () => {
	return (
		<Box>
			<TicketsSales />
			<TicketsTables />
			<EventActions />
		</Box>
	);
};

export default TableAndTickets;
